export const isUserExistsInGroup = (groups: string[] | null, groupName: string) => {
  return groups !== null ? groups.includes(groupName) : false
}